import { addMinutes, differenceInMinutes, parse, subMinutes } from "date-fns";

export type TimeOption = {
  id: string | undefined;
  time: string | undefined;
};

// This function is used to get a time buffer of 30 minutes before or after the selected time to aid with our request forms

export const getRequestedTimeBuffer = (
  time: string,
  options: TimeOption[],
  type: "min" | "max"
) => {
  const parsedSelectedTime = parse(time ?? "", "HH:mm:ss", new Date());
  // Add 30 minutes to the selected time if the type is "max" or subtract 30 minutes if the type is "min"
  const timeGoal =
    type === "max"
      ? addMinutes(parsedSelectedTime, 30)
      : subMinutes(parsedSelectedTime, 30);

  const isEarliestOption = type === "min" && time === options?.[0]?.time;
  const isLatestOption =
    type === "max" && time === options?.[options.length - 1]?.time;

  const optionsToSearch = type === "min" ? options : options.reverse();

  // If the selected time is the earliest or latest option, return the selected time and then find the closest time to the buffer time
  const bufferTime =
    isEarliestOption || isLatestOption
      ? time
      : optionsToSearch?.find((o) => {
          const dateTime = parse(o.time ?? "", "HH:mm:ss", new Date());
          const difference = Math.abs(differenceInMinutes(dateTime, timeGoal));
          return difference <= 2;
        })?.time ?? time;

  return bufferTime;
};
